import React, { useEffect, useRef, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Alert from "../ui/Alert";
import TextButton from "../ui/TextButton";
import { kbdEvent } from "../utils/Utils";
import Button from "../ui/Button";

export default function Confirm(props) {
    const {
        route = "",
        events = [],
        callback = () => { },
        title = "Confirm?",
        description = "",
        defaultYes = false,
    } = props;

    const yesRef = useRef(null);
    const noRef = useRef(null);
    const [focusedIndex, setFocusedIndex] = useState((defaultYes) ? 0 : 1);

    useEffect(() => {

        const actions = [
            { key: KBD.ESCAPE, action: () => callback(false) },
            { key: KBD.Y, action: () => callback(true) },
            { key: KBD.N, action: () => callback(false) },
            { key: KBD.ARROW_LEFT, action: () => setFocusedIndex((prev) => (prev === 0 ? 1 : 0)) },
            { key: KBD.ARROW_RIGHT, action: () => setFocusedIndex((prev) => (prev === 0 ? 1 : 0)) },
            {
                key: KBD.TAB, action: (e) => {
                    e.preventDefault();
                    setFocusedIndex((prev) => (prev + 1) % 2);
                }
            },
            {
                key: KBD.SHIFT_TAB, action: (e) => {
                    e.preventDefault();
                    setFocusedIndex((prev) => (prev + 1) % 2);
                }
            },
            ...events.map((item) => ({ key: item, action: () => callback(item) }))
        ];

        const cleanup = listen(route, actions, false);
        return cleanup;
    }, [events, callback, route]);

    useEffect(() => {
        (focusedIndex === 0 ? yesRef : noRef)?.current?.focus();
    }, [focusedIndex]);

    useEffect(() => {
        if (defaultYes) {
            yesRef.current?.focus();
        } else {
            noRef.current?.focus();
        }
    }, [defaultYes]);

    return (
        <Alert
            title={title}
            dismissible
            callback={callback}
            description={
                <>
                    {description}
                    <div style={{ margin: "0 auto", width: "160px", textAlign: "center" }}>
                        <div className="shim" /><div className="shim" /><div className="shim" />
                        <TextButton ref={yesRef} onEnter={() => kbdEvent(KBD.Y)} onClick={() => kbdEvent(KBD.Y)}>
                            <strong>Y</strong>es
                        </TextButton>
                        &nbsp;
                        <TextButton ref={noRef} onEnter={() => kbdEvent(KBD.Y)} onClick={() => kbdEvent(KBD.N)}>
                            <strong>N</strong>o
                        </TextButton>
                    </div>

                </>
            }
        />
    );
}
